import Toast from 'react-native-toast-message'
import * as Sentry from '@sentry/react-native';

/**
 * Handles errors by displaying them to the user and logging them to Sentry.
 * @param {Error} errorObject - The error object to handle.
 * @param {object} [additionalData] - Optional additional data to include in the error report.
 * @param {string} [userFriendlyMessage] - Optional message to display to the user.
 * @returns {void}
 */
const ErrorHandler = (errorObject, additionalData = {}, userFriendlyMessage) => {

    //Normal error, just process it
    if(errorObject instanceof Error){
        if(errorObject.message.includes("Network request failed") || errorObject.message.includes("Network request timed out") || errorObject.message.includes("Request timed out") || errorObject.message.includes("Request queue is full") || errorObject.message.includes("fetch failed") || errorObject.message.includes("Failed to fetch") || errorObject.message.includes("Failed to send a request to the Edge Function") || errorObject.message.includes("Load failed")){
            // Network errors are handled globally by the query system
            throw errorObject;
        }
        else if(errorObject.message.includes("new row violates row-level security policy")){
            Sentry.logger.warn(`Violation of RLS policy`, {
                ...additionalData,
                error: errorObject.message
            })

            Toast.show({
                type: 'error',
                text2: `You don't seem to have permission to ${additionalData?.mutation ?? 'perform this action'}. Contact your Reach administrator if you think this is incorrect to have them grant you the correct permissions.`
            });
        }
        else{
            recordError(errorObject, additionalData);

            if(userFriendlyMessage){
                Toast.show({
                    type: 'error',
                    text2: userFriendlyMessage
                });
            }
        }
    }
}

export default ErrorHandler


/**
 * Log errors to Sentry (only in production mode)
 * @param {Error} error - The error object to send to Sentry
 * @param {object} extra [extra={}]
 * @returns {void}
 */
const recordError = (error, extra = {}) => {
    Sentry.captureException(error, {extra: extra ? {...extra} : undefined});

    if(__DEV__){
        console.debug('Handled Error: ', JSON.stringify({message: error.message, extra: extra}, null, 2))
    }
}